import { useGetAllProductImagesQuery } from 'services/productImage.service';

export const useProductImagesMap = (
  productVersionIds: string[],
): { imagesMap: Record<string, string[]> | undefined; isLoading: boolean } => {
  const formatted = productVersionIds.map((item) => `'${item}'`).join(', ');
  const { data, isLoading } = useGetAllProductImagesQuery(
    {
      query: {
        filter: `productVersionId:in:[${formatted}]`,
        include: 'image',
      },
    },
    {
      skip: !productVersionIds.length,
    },
  );

  if (isLoading || !data) {
    return { imagesMap: undefined, isLoading };
  }

  const productImagesMap = data.data.rows.reduce(
    (acc, item) => {
      const productVersionId = item.productVersionId;
      const filePath = item.image?.filePath;

      if (productVersionId && filePath) {
        if (!acc[productVersionId]) {
          acc[productVersionId] = [];
        }
        acc[productVersionId].push(filePath);
      }

      return acc;
    },
    {} as Record<string, string[]>,
  );

  return { imagesMap: productImagesMap, isLoading: false };
};
